// Phase I0.5 — FixtureStatusPill.
// Status indicator used by DailyFixtureRail's FixtureCard. Shows the
// kickoff time for upcoming, a pulsing red LIVE marker (with optional
// minute) for in-play, or a quiet "FT" for settled.

import type { TodayFixture } from "../../super-acca/useTodayFixtures";

export interface FixtureStatusPillProps {
  status: TodayFixture["status"];
  kickoff: string;
  minute?: number;
}

export function FixtureStatusPill({ status, kickoff, minute }: FixtureStatusPillProps) {
  if (status === "live") {
    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 5,
          fontFamily: "var(--sa-font-mono)",
          fontSize: 9,
          color: "#FF5757",
          letterSpacing: "0.18em",
        }}
      >
        <span
          aria-hidden
          style={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            background: "#FF5757",
            animation: "saFixturePulse 1.2s infinite",
          }}
        />
        LIVE{minute !== undefined ? ` · ${minute}'` : ""}
      </span>
    );
  }
  if (status === "settled") {
    return (
      <span
        style={{
          fontFamily: "var(--sa-font-mono)",
          fontSize: 9,
          color: "var(--sa-fg-muted)",
          letterSpacing: "0.18em",
        }}
      >
        FT
      </span>
    );
  }
  return (
    <span
      style={{
        fontFamily: "var(--sa-font-mono)",
        fontSize: 10,
        color: "var(--sa-accent-saffron)",
        letterSpacing: "0.14em",
      }}
    >
      {kickoff}
    </span>
  );
}
